<template>
  <div class="profile">
    <ui-title :title="t('profile.title')" :wave="'/profileTitleBg.png'" />
    <div class="profile__wrapper">
      <div class="profile__sidebar">
        <router-link
            :to="translations.i18nRoute({ name: 'profile-orders' })"
            class="profile__sidebar-item"
            :class="[{active: route.name === 'profile-orders'}]"
        >
          {{ t('profile.sidebar.orderHistory') }}
        </router-link>
        <router-link
            :to="translations.i18nRoute({ name: 'profile-info' })"
            class="profile__sidebar-item"
            :class="[{active: route.name === 'profile-info'}]"
        >
          {{ t('profile.sidebar.profileInfo') }}
        </router-link>
        <router-link
            :to="translations.i18nRoute({ name: 'profile-topup' })"
            class="profile__sidebar-item"
            :class="[{active: route.name === 'profile-topup'}]"
        >
          {{ t('profile.sidebar.topupBalance') }}
        </router-link>
        <div class="profile__sidebar-item" @click="logout">{{ t('profile.sidebar.logout') }}</div>
      </div>
      <div class="profile__main">
        <RouterView v-slot="{ Component }">
          <Transition name="opacity" mode="out-in">
            <component :is="Component" />
          </Transition>
        </RouterView>
        <img class="profile__wave" src="@images/authWave.png" alt="wave">
      </div>
    </div>
  </div>
</template>

<script setup>
import UiTitle from "@/components/ui/ui-title.vue";
import {useI18n} from "vue-i18n";
import {useAuthStore} from "@/stores/auth.js";
import {useRoute, useRouter} from "vue-router";
import {onMounted} from "vue";
import translations from "@/core/helpers/translations.js";

const {t} = useI18n()
const authStore = useAuthStore()
const router = useRouter()
const route = useRoute()

const logout = async () => {
  authStore.setUser({
    user: null,
    accessToken: null
  })

  localStorage.removeItem('fpt-refresh')

  await router.push({
    name: 'home',
    params: {
      locale: localStorage.getItem('fpt-user-locale') || 'en-gb'
    }
  })
}

onMounted(() => {
  if (route.name === 'profile') {
    router.push({
      name: 'profile-orders',
      params: {
        locale: localStorage.getItem('fpt-user-locale') || 'en-gb'
      }
    })
  }
})
</script>

<style lang="scss" scoped>
.profile {
  top: -103px;

  &__wrapper {
    display: flex;
    align-items: flex-start;
  }

  &__sidebar {
    width: fit-content;
    background-color: #F3FAFD;
    padding: 56px 38px;
    display: flex;
    flex-direction: column;
    gap: 24px;

    &-item {
      width: 242px;
      cursor: pointer;
      padding-block: 10px;
      border-radius: 30px;
      border: 1px solid #5B194F;
      background-color: $white;
      transition: 0.2s;

      color: #2B3044;
      text-align: center;
      font-family: Syne, sans-serif;
      font-size: 16px;
      font-weight: 700;

      &:hover {
        background-color: #cccccc;
      }

      &:last-child {
        margin-top: 150px;
      }

      &.active {
        background-color: #2B3044;

        color: $white;
        font-size: 20px;
      }
    }
  }

  &__main {
    width: 100%;
    min-height: 510px;
    background-color: $white;
    padding: 60px 100px;
    position: relative;
  }

  &__wave {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

@media (max-width: 1200px) {
  .profile {
    &__wrapper {
      flex-direction: column;
      align-items: center;
    }

    &__sidebar-item:last-child {
      margin-top: 0;
    }
  }
}

@media (max-width: 500px) {
  .profile {
    &__main {
      padding: 30px 50px;
    }
  }
}
</style>